module.exports = __webpack_public_path__ + "img/banner_incorrect.812eb298.svg";